module.exports = __webpack_public_path__ + "static/media/camera_on.a9df7090.svg";